/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 * @generated
 *
 * Run `./dev-cli api-docs` to regenerate.
 */

/* eslint-disable @discordapp/discord/mark-discordapp-com */

export default [
  {
    key: 'CHANGE_LOG',
    name: 'Change Log',
    sidebarLabel: 'Change Log',
    filename: 'change-log.mdx',
    category: null,
    subPath: 'change-log',
    route: '/docs/change-log',
    subpages: [],
  },
  {
    key: 'INTRO',
    name: 'Intro',
    sidebarLabel: 'Intro',
    filename: 'intro.mdx',
    category: null,
    subPath: 'intro',
    route: '/docs/intro',
    subpages: [],
  },
  {
    key: 'REFERENCE',
    name: 'API Reference',
    sidebarLabel: 'API Reference',
    filename: 'reference.mdx',
    category: null,
    subPath: 'reference',
    route: '/docs/reference',
    subpages: [],
  },
  {
    key: 'ACTIVITIES_BUILDING_AN_ACTIVITY',
    name: 'Building Your First Activity in Discord',
    sidebarLabel: 'Quickstart',
    filename: 'building-an-activity.mdx',
    category: 'activities',
    subPath: 'activities/building-an-activity',
    route: '/docs/activities/building-an-activity',
    subpages: [],
  },
  {
    key: 'ACTIVITIES_DESIGN_PATTERNS',
    name: 'Activity Design Patterns',
    sidebarLabel: 'Design Patterns',
    filename: 'design-patterns.mdx',
    category: 'activities',
    subPath: 'activities/design-patterns',
    route: '/docs/activities/design-patterns',
    subpages: [],
  },
  {
    key: 'ACTIVITIES_DEVELOPMENT_GUIDES',
    name: 'Activity Development Guides',
    sidebarLabel: 'Development Guides',
    filename: 'development-guides.mdx',
    category: 'activities',
    subPath: 'activities/development-guides',
    route: '/docs/activities/development-guides',
    subpages: [],
  },
  {
    key: 'ACTIVITIES_HOW_ACTIVITIES_WORK',
    name: 'How Activities Work',
    sidebarLabel: 'How Activities Work',
    filename: 'how-activities-work.md',
    category: 'activities',
    subPath: 'activities/how-activities-work',
    route: '/docs/activities/how-activities-work',
    subpages: [],
  },
  {
    key: 'ACTIVITIES_OVERVIEW',
    name: 'Overview of Activities',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'activities',
    subPath: 'activities/overview',
    route: '/docs/activities/overview',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_07_19_BREAKING_CHANGE_VERSION_6',
    name: 'Breaking Change: Version 6',
    sidebarLabel: 'Breaking Change: Version 6',
    filename: '2017-07-19-breaking-change-version-6.md',
    category: 'change-log',
    subPath: 'change-log/2017-07-19-breaking-change-version-6',
    route: '/docs/change-log/2017-07-19-breaking-change-version-6',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_07_24_NEW_FEATURE_AUDIT_LOGS',
    name: 'New Feature: Audit Logs',
    sidebarLabel: 'New Feature: Audit Logs',
    filename: '2017-07-24-new-feature-audit-logs.md',
    category: 'change-log',
    subPath: 'change-log/2017-07-24-new-feature-audit-logs',
    route: '/docs/change-log/2017-07-24-new-feature-audit-logs',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_08_03_BREAKING_CHANGE_DEFAULT_CHANNELS',
    name: 'Breaking Change: Default Channels',
    sidebarLabel: 'Breaking Change: Default Channels',
    filename: '2017-08-03-breaking-change-default-channels.md',
    category: 'change-log',
    subPath: 'change-log/2017-08-03-breaking-change-default-channels',
    route: '/docs/change-log/2017-08-03-breaking-change-default-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_08_16_BREAKING_CHANGE_PRESENCE_ACTIVITY_OBJECTS',
    name: 'Breaking Change: Presence Activity Objects',
    sidebarLabel: 'Breaking Change: Presence Activity Objects',
    filename: '2017-08-16-breaking-change-presence-activity-objects.md',
    category: 'change-log',
    subPath: 'change-log/2017-08-16-breaking-change-presence-activity-objects',
    route: '/docs/change-log/2017-08-16-breaking-change-presence-activity-objects',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_09_10_NEW_FEATURE_EMOJI_ENDPOINTS',
    name: 'New Feature: Emoji Endpoints',
    sidebarLabel: 'New Feature: Emoji Endpoints',
    filename: '2017-09-10-new-feature-emoji-endpoints.md',
    category: 'change-log',
    subPath: 'change-log/2017-09-10-new-feature-emoji-endpoints',
    route: '/docs/change-log/2017-09-10-new-feature-emoji-endpoints',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_09_20_NEW_FEATURE_CHANNEL_CATEGORIES',
    name: 'New Feature: Channel Categories',
    sidebarLabel: 'New Feature: Channel Categories',
    filename: '2017-09-20-new-feature-channel-categories.md',
    category: 'change-log',
    subPath: 'change-log/2017-09-20-new-feature-channel-categories',
    route: '/docs/change-log/2017-09-20-new-feature-channel-categories',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_10_16_BREAKING_CHANGE_API_GATEWAY_BELOW_V6_DISCONTINUED',
    name: 'Breaking Change: API & Gateway Below v6 Discontinued',
    sidebarLabel: 'Breaking Change: API & Gateway Below v6 Discontinued',
    filename: '2017-10-16-breaking-change-api-gateway-below-v6-discontinued.md',
    category: 'change-log',
    subPath: 'change-log/2017-10-16-breaking-change-api-gateway-below-v6-discontinued',
    route: '/docs/change-log/2017-10-16-breaking-change-api-gateway-below-v6-discontinued',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2017_11_09_NEW_FEATURE_RICH_PRESENCE',
    name: 'New Feature: Rich Presence',
    sidebarLabel: 'New Feature: Rich Presence',
    filename: '2017-11-09-new-feature-rich-presence.md',
    category: 'change-log',
    subPath: 'change-log/2017-11-09-new-feature-rich-presence',
    route: '/docs/change-log/2017-11-09-new-feature-rich-presence',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_01_03_SEMI_BREAKING_CHANGE_VERY_LARGE_BOT_SHARDING',
    name: 'Semi-Breaking Change: Very Large Bot Sharding',
    sidebarLabel: 'Semi-Breaking Change: Very Large Bot Sharding',
    filename: '2018-01-03-semi-breaking-change-very-large-bot-sharding.md',
    category: 'change-log',
    subPath: 'change-log/2018-01-03-semi-breaking-change-very-large-bot-sharding',
    route: '/docs/change-log/2018-01-03-semi-breaking-change-very-large-bot-sharding',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_01_23_DEPRECATION_ACCEPT_INVITE_ENDPOINT',
    name: 'Deprecation: Accept Invite Endpoint',
    sidebarLabel: 'Deprecation: Accept Invite Endpoint',
    filename: '2018-01-23-deprecation-accept-invite-endpoint.md',
    category: 'change-log',
    subPath: 'change-log/2018-01-23-deprecation-accept-invite-endpoint',
    route: '/docs/change-log/2018-01-23-deprecation-accept-invite-endpoint',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_01_30_ENHANCEMENT_GET_GUILD_EMOJI_ENDPOINT',
    name: 'Enhancement: Get Guild Emoji Endpoint',
    sidebarLabel: 'Enhancement: Get Guild Emoji Endpoint',
    filename: '2018-01-30-enhancement-get-guild-emoji-endpoint.md',
    category: 'change-log',
    subPath: 'change-log/2018-01-30-enhancement-get-guild-emoji-endpoint',
    route: '/docs/change-log/2018-01-30-enhancement-get-guild-emoji-endpoint',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_02_05_ENHANCEMENT_NEW_MESSAGE_PROPERTIES',
    name: 'Enhancement: New Message Properties',
    sidebarLabel: 'Enhancement: New Message Properties',
    filename: '2018-02-05-enhancement-new-message-properties.md',
    category: 'change-log',
    subPath: 'change-log/2018-02-05-enhancement-new-message-properties',
    route: '/docs/change-log/2018-02-05-enhancement-new-message-properties',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_06_11_DEPRECATION_RPC_ONLINE_MEMBER_COUNT_AND_MEMBERS_LIST',
    name: 'Deprecation: RPC online member count and members list',
    sidebarLabel: 'Deprecation: RPC online member count and members list',
    filename: '2018-06-11-deprecation-rpc-online-member-count-and-members-list.md',
    category: 'change-log',
    subPath: 'change-log/2018-06-11-deprecation-rpc-online-member-count-and-members-list',
    route: '/docs/change-log/2018-06-11-deprecation-rpc-online-member-count-and-members-list',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_06_19_DOCUMENTATION_FIX_LIST_OF_OPEN_DMS_IN_CERTAIN_PAYLOADS',
    name: 'Documentation Fix: List of Open DMS in Certain Payloads',
    sidebarLabel: 'Documentation Fix: List of Open DMS in Certain Payloads',
    filename: '2018-06-19-documentation-fix-list-of-open-dms-in-certain-payloads.md',
    category: 'change-log',
    subPath: 'change-log/2018-06-19-documentation-fix-list-of-open-dms-in-certain-payloads',
    route: '/docs/change-log/2018-06-19-documentation-fix-list-of-open-dms-in-certain-payloads',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_11_30_ENHANCEMENT_USER_OBJECT',
    name: 'Enhancement: User Object',
    sidebarLabel: 'Enhancement: User Object',
    filename: '2018-11-30-enhancement-user-object.md',
    category: 'change-log',
    subPath: 'change-log/2018-11-30-enhancement-user-object',
    route: '/docs/change-log/2018-11-30-enhancement-user-object',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2018_12_11_DOCUMENTATION_DISPATCH_STORE_LISTINGS',
    name: 'Documentation: Dispatch Store Listings',
    sidebarLabel: 'Documentation: Dispatch Store Listings',
    filename: '2018-12-11-documentation-dispatch-store-listings.md',
    category: 'change-log',
    subPath: 'change-log/2018-12-11-documentation-dispatch-store-listings',
    route: '/docs/change-log/2018-12-11-documentation-dispatch-store-listings',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_01_14_ASK_TO_JOIN_RICH_PRESENCE_SDK',
    name: 'Ask to Join & Rich Presence SDK',
    sidebarLabel: 'Ask to Join & Rich Presence SDK',
    filename: '2019-01-14-ask-to-join-rich-presence-sdk.md',
    category: 'change-log',
    subPath: 'change-log/2019-01-14-ask-to-join-rich-presence-sdk',
    route: '/docs/change-log/2019-01-14-ask-to-join-rich-presence-sdk',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_04_18_NEW_INVITE_OBJECT_FIELDS',
    name: 'New Invite Object Fields',
    sidebarLabel: 'New Invite Object Fields',
    filename: '2019-04-18-new-invite-object-fields.md',
    category: 'change-log',
    subPath: 'change-log/2019-04-18-new-invite-object-fields',
    route: '/docs/change-log/2019-04-18-new-invite-object-fields',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_04_29_DEPRECATION_OF_DISCORD_RPC_RICH_PRESENCE_SDK',
    name: 'Deprecation of Discord-RPC Rich Presence SDK',
    sidebarLabel: 'Deprecation of Discord-RPC Rich Presence SDK',
    filename: '2019-04-29-deprecation-of-discord-rpc-rich-presence-sdk.md',
    category: 'change-log',
    subPath: 'change-log/2019-04-29-deprecation-of-discord-rpc-rich-presence-sdk',
    route: '/docs/change-log/2019-04-29-deprecation-of-discord-rpc-rich-presence-sdk',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_05_29_ADDED_INFO_AROUND_NITRO_BOOSTING_EXPERIMENT',
    name: 'Added Info Around Nitro Boosting Experiment',
    sidebarLabel: 'Added Info Around Nitro Boosting Experiment',
    filename: '2019-05-29-added-info-around-nitro-boosting-experiment.md',
    category: 'change-log',
    subPath: 'change-log/2019-05-29-added-info-around-nitro-boosting-experiment',
    route: '/docs/change-log/2019-05-29-added-info-around-nitro-boosting-experiment',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_06_19_ADDITIONAL_TEAM_INFORMATION',
    name: 'Additional Team Information',
    sidebarLabel: 'Additional Team Information',
    filename: '2019-06-19-additional-team-information.md',
    category: 'change-log',
    subPath: 'change-log/2019-06-19-additional-team-information',
    route: '/docs/change-log/2019-06-19-additional-team-information',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_07_18_BOT_TOKENS_FOR_ACHIEVEMENTS',
    name: 'Bot Tokens for Achievements',
    sidebarLabel: 'Bot Tokens for Achievements',
    filename: '2019-07-18-bot-tokens-for-achievements.md',
    category: 'change-log',
    subPath: 'change-log/2019-07-18-bot-tokens-for-achievements',
    route: '/docs/change-log/2019-07-18-bot-tokens-for-achievements',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_08_12_MORE_PRECISE_RATE_LIMITS',
    name: 'More Precise Rate Limits',
    sidebarLabel: 'More Precise Rate Limits',
    filename: '2019-08-12-more-precise-rate-limits.md',
    category: 'change-log',
    subPath: 'change-log/2019-08-12-more-precise-rate-limits',
    route: '/docs/change-log/2019-08-12-more-precise-rate-limits',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_08_22_CHANGES_TO_SPECIAL_CHANNELS',
    name: 'Changes to Special Channels',
    sidebarLabel: 'Changes to Special Channels',
    filename: '2019-08-22-changes-to-special-channels.md',
    category: 'change-log',
    subPath: 'change-log/2019-08-22-changes-to-special-channels',
    route: '/docs/change-log/2019-08-22-changes-to-special-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_11_14_GAMESDK_VERSION_2',
    name: 'GameSDK Version 2.5.5',
    sidebarLabel: 'GameSDK Version 2.5.5',
    filename: '2019-11-14-gamesdk-version-2.5.5.md',
    category: 'change-log',
    subPath: 'change-log/2019-11-14-gamesdk-version-2',
    route: '/docs/change-log/2019-11-14-gamesdk-version-2',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_11_27_GAMESDK_VERSION_2',
    name: 'GameSDK Version 2.5.6',
    sidebarLabel: 'GameSDK Version 2.5.6',
    filename: '2019-11-27-gamesdk-version-2.5.6.md',
    category: 'change-log',
    subPath: 'change-log/2019-11-27-gamesdk-version-2',
    route: '/docs/change-log/2019-11-27-gamesdk-version-2',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2019_12_06_IP_DISCOVERY_UPDATES',
    name: 'IP Discovery Updates',
    sidebarLabel: 'IP Discovery Updates',
    filename: '2019-12-06-ip-discovery-updates.md',
    category: 'change-log',
    subPath: 'change-log/2019-12-06-ip-discovery-updates',
    route: '/docs/change-log/2019-12-06-ip-discovery-updates',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_02_14_GATEWAY_INTENTS',
    name: 'Gateway Intents',
    sidebarLabel: 'Gateway Intents',
    filename: '2020-02-14-gateway-intents.md',
    category: 'change-log',
    subPath: 'change-log/2020-02-14-gateway-intents',
    route: '/docs/change-log/2020-02-14-gateway-intents',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_02_26_RICH_PRESENCE_SPECTATE_APPROVAL',
    name: 'Rich Presence Spectate Approval',
    sidebarLabel: 'Rich Presence Spectate Approval',
    filename: '2020-02-26-rich-presence-spectate-approval.md',
    category: 'change-log',
    subPath: 'change-log/2020-02-26-rich-presence-spectate-approval',
    route: '/docs/change-log/2020-02-26-rich-presence-spectate-approval',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_03_02_NEW_INVITE_EVENTS_AND_REACTIONS_ENDPOINT',
    name: 'New Invite Events and Reactions Endpoint',
    sidebarLabel: 'New Invite Events and Reactions Endpoint',
    filename: '2020-03-02-new-invite-events-and-reactions-endpoint.md',
    category: 'change-log',
    subPath: 'change-log/2020-03-02-new-invite-events-and-reactions-endpoint',
    route: '/docs/change-log/2020-03-02-new-invite-events-and-reactions-endpoint',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_03_03_NEW_ALLOWED_MENTIONS_OBJECT',
    name: 'New Allowed Mentions Object',
    sidebarLabel: 'New Allowed Mentions Object',
    filename: '2020-03-03-new-allowed-mentions-object.md',
    category: 'change-log',
    subPath: 'change-log/2020-03-03-new-allowed-mentions-object',
    route: '/docs/change-log/2020-03-03-new-allowed-mentions-object',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_04_24_NEW_PROPERTIES_ON_GUILD_MEMBERS_CHUNK_EVENT',
    name: 'New Properties on Guild Members Chunk Event',
    sidebarLabel: 'New Properties on Guild Members Chunk Event',
    filename: '2020-04-24-new-properties-on-guild-members-chunk-event.md',
    category: 'change-log',
    subPath: 'change-log/2020-04-24-new-properties-on-guild-members-chunk-event',
    route: '/docs/change-log/2020-04-24-new-properties-on-guild-members-chunk-event',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_05_11_LEGACY_MENTION_BEHAVIOR_DEPRECATION',
    name: 'Legacy Mention Behavior Deprecation',
    sidebarLabel: 'Legacy Mention Behavior Deprecation',
    filename: '2020-05-11-legacy-mention-behavior-deprecation.md',
    category: 'change-log',
    subPath: 'change-log/2020-05-11-legacy-mention-behavior-deprecation',
    route: '/docs/change-log/2020-05-11-legacy-mention-behavior-deprecation',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_07_28_NEW_PERMISSION_FIELDS',
    name: 'New Permission Fields',
    sidebarLabel: 'New Permission Fields',
    filename: '2020-07-28-new-permission-fields.md',
    category: 'change-log',
    subPath: 'change-log/2020-07-28-new-permission-fields',
    route: '/docs/change-log/2020-07-28-new-permission-fields',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_09_24_API_AND_GATEWAY_V8',
    name: 'API and Gateway V8',
    sidebarLabel: 'API and Gateway V8',
    filename: '2020-09-24-api-and-gateway-v8.md',
    category: 'change-log',
    subPath: 'change-log/2020-09-24-api-and-gateway-v8',
    route: '/docs/change-log/2020-09-24-api-and-gateway-v8',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_10_27_GATEWAY_V6_INTENT_RESTRICTIONS',
    name: 'Gateway v6 Intent Restrictions',
    sidebarLabel: 'Gateway v6 Intent Restrictions',
    filename: '2020-10-27-gateway-v6-intent-restrictions.md',
    category: 'change-log',
    subPath: 'change-log/2020-10-27-gateway-v6-intent-restrictions',
    route: '/docs/change-log/2020-10-27-gateway-v6-intent-restrictions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_11_13_STICKERS',
    name: 'Stickers',
    sidebarLabel: 'Stickers',
    filename: '2020-11-13-stickers.md',
    category: 'change-log',
    subPath: 'change-log/2020-11-13-stickers',
    route: '/docs/change-log/2020-11-13-stickers',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_11_16_INLINE_REPLIES',
    name: 'Inline Replies',
    sidebarLabel: 'Inline Replies',
    filename: '2020-11-16-inline-replies.md',
    category: 'change-log',
    subPath: 'change-log/2020-11-16-inline-replies',
    route: '/docs/change-log/2020-11-16-inline-replies',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2020_12_15_SLASH_COMMANDS_AND_INTERACTIONS',
    name: 'Slash Commands and Interactions',
    sidebarLabel: 'Slash Commands and Interactions',
    filename: '2020-12-15-slash-commands-and-interactions.md',
    category: 'change-log',
    subPath: 'change-log/2020-12-15-slash-commands-and-interactions',
    route: '/docs/change-log/2020-12-15-slash-commands-and-interactions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_01_22_CHANGE_TO_PERMISSION_CHECKING_WHEN_CREATING_CHANNELS',
    name: 'Change to Permission Checking when Creating Channels',
    sidebarLabel: 'Change to Permission Checking when Creating Channels',
    filename: '2021-01-22-change-to-permission-checking-when-creating-channels.md',
    category: 'change-log',
    subPath: 'change-log/2021-01-22-change-to-permission-checking-when-creating-channels',
    route: '/docs/change-log/2021-01-22-change-to-permission-checking-when-creating-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_02_09_SLASH_COMMANDS_IN_DMS',
    name: 'Slash Commands in DMs',
    sidebarLabel: 'Slash Commands in DMs',
    filename: '2021-02-09-slash-commands-in-dms.md',
    category: 'change-log',
    subPath: 'change-log/2021-02-09-slash-commands-in-dms',
    route: '/docs/change-log/2021-02-09-slash-commands-in-dms',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_03_05_CHANGES_TO_SLASH_COMMAND_RESPONSE_TYPES_AND_FLAGS',
    name: 'Changes to Slash Command Response Types and Flags',
    sidebarLabel: 'Changes to Slash Command Response Types and Flags',
    filename: '2021-03-05-changes-to-slash-command-response-types-and-flags.md',
    category: 'change-log',
    subPath: 'change-log/2021-03-05-changes-to-slash-command-response-types-and-flags',
    route: '/docs/change-log/2021-03-05-changes-to-slash-command-response-types-and-flags',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_03_15_LARGE_BOT_SHARDING_LOWERED_TO_150_000_GUILDS',
    name: 'Large Bot Sharding Lowered to 150,000 Guilds',
    sidebarLabel: 'Large Bot Sharding Lowered to 150,000 Guilds',
    filename: '2021-03-15-large-bot-sharding-lowered-to-150-000-guilds.md',
    category: 'change-log',
    subPath: 'change-log/2021-03-15-large-bot-sharding-lowered-to-150-000-guilds',
    route: '/docs/change-log/2021-03-15-large-bot-sharding-lowered-to-150-000-guilds',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_04_05_APPLICATION_COMMAND_PERMISSIONS',
    name: 'Application Command Permissions',
    sidebarLabel: 'Application Command Permissions',
    filename: '2021-04-05-application-command-permissions.md',
    category: 'change-log',
    subPath: 'change-log/2021-04-05-application-command-permissions',
    route: '/docs/change-log/2021-04-05-application-command-permissions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_04_28_API_V9',
    name: 'API v9',
    sidebarLabel: 'API v9',
    filename: '2021-04-28-api-v9.md',
    category: 'change-log',
    subPath: 'change-log/2021-04-28-api-v9',
    route: '/docs/change-log/2021-04-28-api-v9',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_05_26_BUTTONS_AND_MESSAGE_COMPONENTS',
    name: 'Buttons and Message Components',
    sidebarLabel: 'Buttons and Message Components',
    filename: '2021-05-26-buttons-and-message-components.md',
    category: 'change-log',
    subPath: 'change-log/2021-05-26-buttons-and-message-components',
    route: '/docs/change-log/2021-05-26-buttons-and-message-components',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_06_10_SUPPORT_FOR_MULTIPLE_EMBEDS_IN_MESSAGE_ROUTES',
    name: 'Support for Multiple Embeds in Message Routes',
    sidebarLabel: 'Support for Multiple Embeds in Message Routes',
    filename: '2021-06-10-support-for-multiple-embeds-in-message-routes.md',
    category: 'change-log',
    subPath: 'change-log/2021-06-10-support-for-multiple-embeds-in-message-routes',
    route: '/docs/change-log/2021-06-10-support-for-multiple-embeds-in-message-routes',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_06_30_SELECT_MENU_COMPONENTS',
    name: 'Select Menu Components',
    sidebarLabel: 'Select Menu Components',
    filename: '2021-06-30-select-menu-components.md',
    category: 'change-log',
    subPath: 'change-log/2021-06-30-select-menu-components',
    route: '/docs/change-log/2021-06-30-select-menu-components',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_08_10_USER_AND_MESSAGE_COMMANDS',
    name: 'User and Message Commands',
    sidebarLabel: 'User and Message Commands',
    filename: '2021-08-10-user-and-message-commands.md',
    category: 'change-log',
    subPath: 'change-log/2021-08-10-user-and-message-commands',
    route: '/docs/change-log/2021-08-10-user-and-message-commands',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_09_16_UPDATED_THREAD_PERMISSIONS',
    name: 'Updated Thread Permissions',
    sidebarLabel: 'Updated Thread Permissions',
    filename: '2021-09-16-updated-thread-permissions.md',
    category: 'change-log',
    subPath: 'change-log/2021-09-16-updated-thread-permissions',
    route: '/docs/change-log/2021-09-16-updated-thread-permissions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_10_27_APPLICATION_COMMAND_AUTOCOMPLETE_INTERACTIONS',
    name: 'Application Command Autocomplete Interactions',
    sidebarLabel: 'Application Command Autocomplete Interactions',
    filename: '2021-10-27-application-command-autocomplete-interactions.md',
    category: 'change-log',
    subPath: 'change-log/2021-10-27-application-command-autocomplete-interactions',
    route: '/docs/change-log/2021-10-27-application-command-autocomplete-interactions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_11_23_GUILD_SCHEDULED_EVENTS',
    name: 'Guild Scheduled Events',
    sidebarLabel: 'Guild Scheduled Events',
    filename: '2021-11-23-guild-scheduled-events.md',
    category: 'change-log',
    subPath: 'change-log/2021-11-23-guild-scheduled-events',
    route: '/docs/change-log/2021-11-23-guild-scheduled-events',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2021_12_20_GUILD_MEMBER_TIMEOUTS',
    name: 'Guild Member Timeouts',
    sidebarLabel: 'Guild Member Timeouts',
    filename: '2021-12-20-guild-member-timeouts.md',
    category: 'change-log',
    subPath: 'change-log/2021-12-20-guild-member-timeouts',
    route: '/docs/change-log/2021-12-20-guild-member-timeouts',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_02_08_INTERACTION_MODALS_AND_APPLICATION_COMMAND_ATTACHMENT_OPTION_TYPE',
    name: 'Interaction Modals and Application Command Attachment Option Type',
    sidebarLabel: 'Interaction Modals and Application Command Attachment Option Type',
    filename: '2022-02-08-interaction-modals-and-application-command-attachment-option-type.md',
    category: 'change-log',
    subPath: 'change-log/2022-02-08-interaction-modals-and-application-command-attachment-option-type',
    route: '/docs/change-log/2022-02-08-interaction-modals-and-application-command-attachment-option-type',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_02_14_API_V10',
    name: 'API v10',
    sidebarLabel: 'API v10',
    filename: '2022-02-14-api-v10.md',
    category: 'change-log',
    subPath: 'change-log/2022-02-14-api-v10',
    route: '/docs/change-log/2022-02-14-api-v10',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_03_31_GUILD_BANS_PAGINATION',
    name: 'Guild Bans Pagination',
    sidebarLabel: 'Guild Bans Pagination',
    filename: '2022-03-31-guild-bans-pagination.md',
    category: 'change-log',
    subPath: 'change-log/2022-03-31-guild-bans-pagination',
    route: '/docs/change-log/2022-03-31-guild-bans-pagination',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_04_06_FORUM_CHANNELS',
    name: 'Forum Channels',
    sidebarLabel: 'Forum Channels',
    filename: '2022-04-06-forum-channels.md',
    category: 'change-log',
    subPath: 'change-log/2022-04-06-forum-channels',
    route: '/docs/change-log/2022-04-06-forum-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_04_27_UPDATED_COMMAND_PERMISSIONS',
    name: 'Updated Command Permissions',
    sidebarLabel: 'Updated Command Permissions',
    filename: '2022-04-27-updated-command-permissions.md',
    category: 'change-log',
    subPath: 'change-log/2022-04-27-updated-command-permissions',
    route: '/docs/change-log/2022-04-27-updated-command-permissions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_06_16_AUTO_MODERATION',
    name: 'Auto Moderation',
    sidebarLabel: 'Auto Moderation',
    filename: '2022-06-16-auto-moderation.md',
    category: 'change-log',
    subPath: 'change-log/2022-06-16-auto-moderation',
    route: '/docs/change-log/2022-06-16-auto-moderation',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_06_17_UPDATED_CONNECTION_PROPERTY_FIELD_NAMES',
    name: 'Updated Connection Property Field Names',
    sidebarLabel: 'Updated Connection Property Field Names',
    filename: '2022-06-17-updated-connection-property-field-names.md',
    category: 'change-log',
    subPath: 'change-log/2022-06-17-updated-connection-property-field-names',
    route: '/docs/change-log/2022-06-17-updated-connection-property-field-names',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_06_21_MESSAGE_CONTENT_IN_AUTO_MODERATION_EVENTS',
    name: 'Message Content in Auto Moderation events',
    sidebarLabel: 'Message Content in Auto Moderation events',
    filename: '2022-06-21-message-content-in-auto-moderation-events.md',
    category: 'change-log',
    subPath: 'change-log/2022-06-21-message-content-in-auto-moderation-events',
    route: '/docs/change-log/2022-06-21-message-content-in-auto-moderation-events',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_06_29_CALCULATED_PERMISSIONS_IN_INTERACTION_PAYLOADS',
    name: 'Calculated Permissions in Interaction Payloads',
    sidebarLabel: 'Calculated Permissions in Interaction Payloads',
    filename: '2022-06-29-calculated-permissions-in-interaction-payloads.md',
    category: 'change-log',
    subPath: 'change-log/2022-06-29-calculated-permissions-in-interaction-payloads',
    route: '/docs/change-log/2022-06-29-calculated-permissions-in-interaction-payloads',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_06_29_CHANGES_TO_BOT_PERMISSIONS_FOR_INTERACTIONS_AND_WEBHOOKS',
    name: 'Changes to Bot Permissions for Interactions and Webhooks',
    sidebarLabel: 'Changes to Bot Permissions for Interactions and Webhooks',
    filename: '2022-06-29-changes-to-bot-permissions-for-interactions-and-webhooks.md',
    category: 'change-log',
    subPath: 'change-log/2022-06-29-changes-to-bot-permissions-for-interactions-and-webhooks',
    route: '/docs/change-log/2022-06-29-changes-to-bot-permissions-for-interactions-and-webhooks',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_07_01_ADD_SUBCOMMAND_GROUPS_AND_SUBCOMMANDS_TO_MESSAGE_INTERACTION_OBJECTS',
    name: 'Add Subcommand Groups and Subcommands to Message Interaction Objects',
    sidebarLabel: 'Add Subcommand Groups and Subcommands to Message Interaction Objects',
    filename: '2022-07-01-add-subcommand-groups-and-subcommands-to-message-interaction-objects.md',
    category: 'change-log',
    subPath: 'change-log/2022-07-01-add-subcommand-groups-and-subcommands-to-message-interaction-objects',
    route: '/docs/change-log/2022-07-01-add-subcommand-groups-and-subcommands-to-message-interaction-objects',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_07_01_MIN_AND_MAX_LENGTH_FOR_COMMAND_OPTIONS',
    name: 'Min and Max Length for Command Options',
    sidebarLabel: 'Min and Max Length for Command Options',
    filename: '2022-07-01-min-and-max-length-for-command-options.md',
    category: 'change-log',
    subPath: 'change-log/2022-07-01-min-and-max-length-for-command-options',
    route: '/docs/change-log/2022-07-01-min-and-max-length-for-command-options',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_07_13_UPCOMING_PERMISSIONS_CHANGE_TO_WEBHOOK_ROUTES',
    name: 'Upcoming Permissions Change to Webhook Routes',
    sidebarLabel: 'Upcoming Permissions Change to Webhook Routes',
    filename: '2022-07-13-upcoming-permissions-change-to-webhook-routes.md',
    category: 'change-log',
    subPath: 'change-log/2022-07-13-upcoming-permissions-change-to-webhook-routes',
    route: '/docs/change-log/2022-07-13-upcoming-permissions-change-to-webhook-routes',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_08_09_SESSION_SPECIFIC_GATEWAY_RESUME_URLS',
    name: 'Session-specific Gateway Resume URLs',
    sidebarLabel: 'Session-specific Gateway Resume URLs',
    filename: '2022-08-09-session-specific-gateway-resume-urls.md',
    category: 'change-log',
    subPath: 'change-log/2022-08-09-session-specific-gateway-resume-urls',
    route: '/docs/change-log/2022-08-09-session-specific-gateway-resume-urls',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_08_22_SLASH_COMMAND_MENTIONS',
    name: 'Slash Command Mentions',
    sidebarLabel: 'Slash Command Mentions',
    filename: '2022-08-22-slash-command-mentions.md',
    category: 'change-log',
    subPath: 'change-log/2022-08-22-slash-command-mentions',
    route: '/docs/change-log/2022-08-22-slash-command-mentions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_09_01_MESSAGE_CONTENT_IS_A_PRIVILEGED_INTENT',
    name: 'Message Content is a Privileged Intent',
    sidebarLabel: 'Message Content is a Privileged Intent',
    filename: '2022-09-01-message-content-is-a-privileged-intent.md',
    category: 'change-log',
    subPath: 'change-log/2022-09-01-message-content-is-a-privileged-intent',
    route: '/docs/change-log/2022-09-01-message-content-is-a-privileged-intent',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_09_14_FORUM_CHANNELS_RELEASE',
    name: 'Forum Channels Release',
    sidebarLabel: 'Forum Channels Release',
    filename: '2022-09-14-forum-channels-release.md',
    category: 'change-log',
    subPath: 'change-log/2022-09-14-forum-channels-release',
    route: '/docs/change-log/2022-09-14-forum-channels-release',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_09_21_AUTO_MODERATION_SPAM_AND_MENTION_SPAM_TRIGGER_TYPES',
    name: 'Auto Moderation Spam and Mention Spam Trigger Types',
    sidebarLabel: 'Auto Moderation Spam and Mention Spam Trigger Types',
    filename: '2022-09-21-auto-moderation-spam-and-mention-spam-trigger-types.md',
    category: 'change-log',
    subPath: 'change-log/2022-09-21-auto-moderation-spam-and-mention-spam-trigger-types',
    route: '/docs/change-log/2022-09-21-auto-moderation-spam-and-mention-spam-trigger-types',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_09_22_DEFAULT_SORT_ORDER_FOR_FORUM_CHANNELS',
    name: 'Default Sort Order for Forum Channels',
    sidebarLabel: 'Default Sort Order for Forum Channels',
    filename: '2022-09-22-default-sort-order-for-forum-channels.md',
    category: 'change-log',
    subPath: 'change-log/2022-09-22-default-sort-order-for-forum-channels',
    route: '/docs/change-log/2022-09-22-default-sort-order-for-forum-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_10_13_NEW_SELECT_MENU_COMPONENTS',
    name: 'New Select Menu Components',
    sidebarLabel: 'New Select Menu Components',
    filename: '2022-10-13-new-select-menu-components.md',
    category: 'change-log',
    subPath: 'change-log/2022-10-13-new-select-menu-components',
    route: '/docs/change-log/2022-10-13-new-select-menu-components',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_10_20_DELETE_EPHEMERAL_MESSAGES',
    name: 'Delete Ephemeral Messages',
    sidebarLabel: 'Delete Ephemeral Messages',
    filename: '2022-10-20-delete-ephemeral-messages.md',
    category: 'change-log',
    subPath: 'change-log/2022-10-20-delete-ephemeral-messages',
    route: '/docs/change-log/2022-10-20-delete-ephemeral-messages',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_11_04_ADD_AUTO_MODERATION_REGEX_SUPPORT',
    name: 'Add Auto Moderation Regex Support',
    sidebarLabel: 'Add Auto Moderation Regex Support',
    filename: '2022-11-04-add-auto-moderation-regex-support.md',
    category: 'change-log',
    subPath: 'change-log/2022-11-04-add-auto-moderation-regex-support',
    route: '/docs/change-log/2022-11-04-add-auto-moderation-regex-support',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_11_09_GAMESDK_FEATURE_DEPRECATION',
    name: 'GameSDK Feature Deprecation',
    sidebarLabel: 'GameSDK Feature Deprecation',
    filename: '2022-11-09-gamesdk-feature-deprecation.md',
    category: 'change-log',
    subPath: 'change-log/2022-11-09-gamesdk-feature-deprecation',
    route: '/docs/change-log/2022-11-09-gamesdk-feature-deprecation',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_11_17_UPCOMING_APPLICATION_COMMAND_PERMISSION_CHANGES',
    name: 'Upcoming Application Command Permission Changes',
    sidebarLabel: 'Upcoming Application Command Permission Changes',
    filename: '2022-11-17-upcoming-application-command-permission-changes.md',
    category: 'change-log',
    subPath: 'change-log/2022-11-17-upcoming-application-command-permission-changes',
    route: '/docs/change-log/2022-11-17-upcoming-application-command-permission-changes',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_11_22_ADD_AUTO_MODERATION_ALLOW_LIST_FOR_KEYWORD_RULES_AND_INCREASE_MAX_KEYWORD_RULES_PER_GUILD_LIMIT',
    name: 'Add Auto Moderation Allow List for Keyword Rules and Increase Max Keyword Rules Per Guild Limit',
    sidebarLabel: 'Add Auto Moderation Allow List for Keyword Rules and Increase Max Keyword Rules Per Guild Limit',
    filename:
      '2022-11-22-add-auto-moderation-allow-list-for-keyword-rules-and-increase-max-keyword-rules-per-guild-limit.md',
    category: 'change-log',
    subPath:
      'change-log/2022-11-22-add-auto-moderation-allow-list-for-keyword-rules-and-increase-max-keyword-rules-per-guild-limit',
    route:
      '/docs/change-log/2022-11-22-add-auto-moderation-allow-list-for-keyword-rules-and-increase-max-keyword-rules-per-guild-limit',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_12_12_ADD_APPLICATION_CONNECTIONS_METADATA_AND_LINKED_ROLES',
    name: 'Add Application Connections Metadata and Linked Roles',
    sidebarLabel: 'Add Application Connections Metadata and Linked Roles',
    filename: '2022-12-12-add-application-connections-metadata-and-linked-roles.md',
    category: 'change-log',
    subPath: 'change-log/2022-12-12-add-application-connections-metadata-and-linked-roles',
    route: '/docs/change-log/2022-12-12-add-application-connections-metadata-and-linked-roles',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2022_12_13_ADD_DEFAULT_LAYOUT_SETTING_FOR_FORUM_CHANNELS',
    name: 'Add Default Layout setting for Forum channels',
    sidebarLabel: 'Add Default Layout setting for Forum channels',
    filename: '2022-12-13-add-default-layout-setting-for-forum-channels.md',
    category: 'change-log',
    subPath: 'change-log/2022-12-13-add-default-layout-setting-for-forum-channels',
    route: '/docs/change-log/2022-12-13-add-default-layout-setting-for-forum-channels',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_01_09_THREAD_MEMBER_DETAILS_AND_PAGINATION',
    name: 'Thread Member Details and Pagination',
    sidebarLabel: 'Thread Member Details and Pagination',
    filename: '2023-01-09-thread-member-details-and-pagination.md',
    category: 'change-log',
    subPath: 'change-log/2023-01-09-thread-member-details-and-pagination',
    route: '/docs/change-log/2023-01-09-thread-member-details-and-pagination',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_01_18_GUILD_AUDIT_LOG_EVENTS',
    name: 'Guild Audit Log Events',
    sidebarLabel: 'Guild Audit Log Events',
    filename: '2023-01-18-guild-audit-log-events.md',
    category: 'change-log',
    subPath: 'change-log/2023-01-18-guild-audit-log-events',
    route: '/docs/change-log/2023-01-18-guild-audit-log-events',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_02_08_INCREASE_AUTO_MODERATION_KEYWORD_LIMITS',
    name: 'Increase Auto Moderation Keyword Limits',
    sidebarLabel: 'Increase Auto Moderation Keyword Limits',
    filename: '2023-02-08-increase-auto-moderation-keyword-limits.md',
    category: 'change-log',
    subPath: 'change-log/2023-02-08-increase-auto-moderation-keyword-limits',
    route: '/docs/change-log/2023-02-08-increase-auto-moderation-keyword-limits',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_02_10_UPDATE_TO_LOCKED_THREADS',
    name: 'Update to Locked Threads',
    sidebarLabel: 'Update to Locked Threads',
    filename: '2023-02-10-update-to-locked-threads.md',
    category: 'change-log',
    subPath: 'change-log/2023-02-10-update-to-locked-threads',
    route: '/docs/change-log/2023-02-10-update-to-locked-threads',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_02_24_ADD_AUTO_MODERATION_CUSTOM_MESSAGE_ACTION_METADATA_FIELD',
    name: 'Add Auto Moderation custom_message Action Metadata Field',
    sidebarLabel: 'Add Auto Moderation custom_message Action Metadata Field',
    filename: '2023-02-24-add-auto-moderation-custom-message-action-metadata-field.md',
    category: 'change-log',
    subPath: 'change-log/2023-02-24-add-auto-moderation-custom-message-action-metadata-field',
    route: '/docs/change-log/2023-02-24-add-auto-moderation-custom-message-action-metadata-field',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_04_06_INTERACTION_CHANNEL_DATA',
    name: 'Interaction Channel Data',
    sidebarLabel: 'Interaction Channel Data',
    filename: '2023-04-06-interaction-channel-data.md',
    category: 'change-log',
    subPath: 'change-log/2023-04-06-interaction-channel-data',
    route: '/docs/change-log/2023-04-06-interaction-channel-data',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_04_14_BOT_USERS_ADDED_TO_ALL_NEW_APPS',
    name: 'Bot users added to all new apps',
    sidebarLabel: 'Bot users added to all new apps',
    filename: '2023-04-14-bot-users-added-to-all-new-apps.md',
    category: 'change-log',
    subPath: 'change-log/2023-04-14-bot-users-added-to-all-new-apps',
    route: '/docs/change-log/2023-04-14-bot-users-added-to-all-new-apps',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_05_03_UNIQUE_USERNAMES_ON_DISCORD',
    name: 'Unique usernames on Discord',
    sidebarLabel: 'Unique usernames on Discord',
    filename: '2023-05-03-unique-usernames-on-discord.md',
    category: 'change-log',
    subPath: 'change-log/2023-05-03-unique-usernames-on-discord',
    route: '/docs/change-log/2023-05-03-unique-usernames-on-discord',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_05_05_ADD_JOIN_RAID_AND_MENTION_RAID_FIELDS',
    name: 'Add Join Raid and Mention Raid fields',
    sidebarLabel: 'Add Join Raid and Mention Raid fields',
    filename: '2023-05-05-add-join-raid-and-mention-raid-fields.md',
    category: 'change-log',
    subPath: 'change-log/2023-05-05-add-join-raid-and-mention-raid-fields',
    route: '/docs/change-log/2023-05-05-add-join-raid-and-mention-raid-fields',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_08_01_NEW_GUILD_MEDIA_CHANNEL_TYPE',
    name: 'New GUILD_MEDIA channel type',
    sidebarLabel: 'New GUILD_MEDIA channel type',
    filename: '2023-08-01-new-guild-media-channel-type.md',
    category: 'change-log',
    subPath: 'change-log/2023-08-01-new-guild-media-channel-type',
    route: '/docs/change-log/2023-08-01-new-guild-media-channel-type',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_08_02_PUBLIC_PREVIEW_OF_OPENAPI_3',
    name: 'Public Preview of OpenAPI 3.1 Specification',
    sidebarLabel: 'Public Preview of OpenAPI 3.1 Specification',
    filename: '2023-08-02-public-preview-of-openapi-3.1-specification.md',
    category: 'change-log',
    subPath: 'change-log/2023-08-02-public-preview-of-openapi-3',
    route: '/docs/change-log/2023-08-02-public-preview-of-openapi-3',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_08_08_ACTIVITY_STATE_FOR_BOT_USERS',
    name: 'Activity State for Bot Users',
    sidebarLabel: 'Activity State for Bot Users',
    filename: '2023-08-08-activity-state-for-bot-users.md',
    category: 'change-log',
    subPath: 'change-log/2023-08-08-activity-state-for-bot-users',
    route: '/docs/change-log/2023-08-08-activity-state-for-bot-users',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_08_10_EMBED_DEBUGGER',
    name: 'Embed Debugger',
    sidebarLabel: 'Embed Debugger',
    filename: '2023-08-10-embed-debugger.md',
    category: 'change-log',
    subPath: 'change-log/2023-08-10-embed-debugger',
    route: '/docs/change-log/2023-08-10-embed-debugger',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_08_23_TEAM_MEMBER_ROLES',
    name: 'Team Member Roles',
    sidebarLabel: 'Team Member Roles',
    filename: '2023-08-23-team-member-roles.md',
    category: 'change-log',
    subPath: 'change-log/2023-08-23-team-member-roles',
    route: '/docs/change-log/2023-08-23-team-member-roles',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_09_22_DEFAULT_VALUE_IN_AUTO_POPULATED_SELECT_MENUS',
    name: 'Default Value in Auto-populated Select Menus',
    sidebarLabel: 'Default Value in Auto-populated Select Menus',
    filename: '2023-09-22-default-value-in-auto-populated-select-menus.md',
    category: 'change-log',
    subPath: 'change-log/2023-09-22-default-value-in-auto-populated-select-menus',
    route: '/docs/change-log/2023-09-22-default-value-in-auto-populated-select-menus',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_09_26_PREMIUM_APP_SUBSCRIPTIONS_AVAILABLE_IN_THE_US',
    name: 'Premium App Subscriptions Available in the US',
    sidebarLabel: 'Premium App Subscriptions Available in the US',
    filename: '2023-09-26-premium-app-subscriptions-available-in-the-us.md',
    category: 'change-log',
    subPath: 'change-log/2023-09-26-premium-app-subscriptions-available-in-the-us',
    route: '/docs/change-log/2023-09-26-premium-app-subscriptions-available-in-the-us',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_10_17_GLOBAL_RATE_LIMIT_ADDED_TO_DISCORD',
    name: 'Global Rate Limit added to discordapp.com/*',
    sidebarLabel: 'Global Rate Limit added to discordapp.com/*',
    filename: '2023-10-17-global-rate-limit-added-to-discord.com.md',
    category: 'change-log',
    subPath: 'change-log/2023-10-17-global-rate-limit-added-to-discord',
    route: '/docs/change-log/2023-10-17-global-rate-limit-added-to-discord',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_10_19_PREMIUM_APP_SUBSCRIPTIONS_NOW_AVAILABLE_IN_THE_EU_AND_UK',
    name: 'Premium App Subscriptions Now Available in the EU and UK',
    sidebarLabel: 'Premium App Subscriptions Now Available in the EU and UK',
    filename: '2023-10-19-premium-app-subscriptions-now-available-in-the-eu-and-uk.md',
    category: 'change-log',
    subPath: 'change-log/2023-10-19-premium-app-subscriptions-now-available-in-the-eu-and-uk',
    route: '/docs/change-log/2023-10-19-premium-app-subscriptions-now-available-in-the-eu-and-uk',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_11_01_FIX_MESSAGE_EDIT_INTERACTION_RESPONSE_PERMISSIONS',
    name: 'Fix Message Edit Interaction Response Permissions',
    sidebarLabel: 'Fix Message Edit Interaction Response Permissions',
    filename: '2023-11-01-fix-message-edit-interaction-response-permissions.md',
    category: 'change-log',
    subPath: 'change-log/2023-11-01-fix-message-edit-interaction-response-permissions',
    route: '/docs/change-log/2023-11-01-fix-message-edit-interaction-response-permissions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_11_29_PREMIUM_APP_SUBSCRIPTIONS_NEW_WAYS_FOR_TESTING_APP_SUBSCRIPTIONS',
    name: 'Premium App Subscriptions: New Ways for Testing App Subscriptions',
    sidebarLabel: 'Premium App Subscriptions: New Ways for Testing App Subscriptions',
    filename: '2023-11-29-premium-app-subscriptions-new-ways-for-testing-app-subscriptions.md',
    category: 'change-log',
    subPath: 'change-log/2023-11-29-premium-app-subscriptions-new-ways-for-testing-app-subscriptions',
    route: '/docs/change-log/2023-11-29-premium-app-subscriptions-new-ways-for-testing-app-subscriptions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_12_01_EXPERIMENTING_WITH_END_TO_END_ENCRYPTION_FOR_VOICE_VIDEO',
    name: 'Experimenting with End-to-End Encryption for Voice & Video',
    sidebarLabel: 'Experimenting with End-to-End Encryption for Voice & Video',
    filename: '2023-12-01-experimenting-with-end-to-end-encryption-for-voice-video.md',
    category: 'change-log',
    subPath: 'change-log/2023-12-01-experimenting-with-end-to-end-encryption-for-voice-video',
    route: '/docs/change-log/2023-12-01-experimenting-with-end-to-end-encryption-for-voice-video',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_12_15_CLARIFICATION_ON_PERMISSION_SPLITS_FOR_EXPRESSIONS_AND_EVENTS',
    name: 'Clarification on Permission Splits for Expressions and Events',
    sidebarLabel: 'Clarification on Permission Splits for Expressions and Events',
    filename: '2023-12-15-clarification-on-permission-splits-for-expressions-and-events.md',
    category: 'change-log',
    subPath: 'change-log/2023-12-15-clarification-on-permission-splits-for-expressions-and-events',
    route: '/docs/change-log/2023-12-15-clarification-on-permission-splits-for-expressions-and-events',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2023_12_19_LIMIT_NUMBER_OF_FIELDS_IN_EMBEDS',
    name: 'Limit Number of Fields in Embeds',
    sidebarLabel: 'Limit Number of Fields in Embeds',
    filename: '2023-12-19-limit-number-of-fields-in-embeds.md',
    category: 'change-log',
    subPath: 'change-log/2023-12-19-limit-number-of-fields-in-embeds',
    route: '/docs/change-log/2023-12-19-limit-number-of-fields-in-embeds',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_00_20_SOUNDBOARD_API',
    name: 'Soundboard API',
    sidebarLabel: 'Soundboard API',
    filename: '2024-00-20-soundboard-api.md',
    category: 'change-log',
    subPath: 'change-log/2024-00-20-soundboard-api',
    route: '/docs/change-log/2024-00-20-soundboard-api',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_02_12_ENFORCED_NONCES_ON_CREATE_MESSAGE_ENDPOINT',
    name: 'Enforced Nonces on Create Message Endpoint',
    sidebarLabel: 'Enforced Nonces on Create Message Endpoint',
    filename: '2024-02-12-enforced-nonces-on-create-message-endpoint.md',
    category: 'change-log',
    subPath: 'change-log/2024-02-12-enforced-nonces-on-create-message-endpoint',
    route: '/docs/change-log/2024-02-12-enforced-nonces-on-create-message-endpoint',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_03_15_GUILD_PRUNE_REQUIRING',
    name: 'Guild Prune Requiring',
    sidebarLabel: 'Guild Prune Requiring',
    filename: '2024-03-15-guild-prune-requiring.md',
    category: 'change-log',
    subPath: 'change-log/2024-03-15-guild-prune-requiring',
    route: '/docs/change-log/2024-03-15-guild-prune-requiring',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_03_18_DISCORD_ACTIVITIES_DEVELOPER_PREVIEW_OF_THE_EMBEDDED_APP_SDK',
    name: 'Discord Activities: Developer Preview of the Embedded App SDK',
    sidebarLabel: 'Discord Activities: Developer Preview of the Embedded App SDK',
    filename: '2024-03-18-discord-activities-developer-preview-of-the-embedded-app-sdk.md',
    category: 'change-log',
    subPath: 'change-log/2024-03-18-discord-activities-developer-preview-of-the-embedded-app-sdk',
    route: '/docs/change-log/2024-03-18-discord-activities-developer-preview-of-the-embedded-app-sdk',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_03_18_USER_INSTALLABLE_APPS_PREVIEW',
    name: 'User-Installable Apps Preview',
    sidebarLabel: 'User-Installable Apps Preview',
    filename: '2024-03-18-user-installable-apps-preview.md',
    category: 'change-log',
    subPath: 'change-log/2024-03-18-user-installable-apps-preview',
    route: '/docs/change-log/2024-03-18-user-installable-apps-preview',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_04_02_CSV_EXPORT_FOR_PREMIUM_APP_ANALYTICS',
    name: 'CSV Export for Premium App Analytics',
    sidebarLabel: 'CSV Export for Premium App Analytics',
    filename: '2024-04-02-csv-export-for-premium-app-analytics.md',
    category: 'change-log',
    subPath: 'change-log/2024-04-02-csv-export-for-premium-app-analytics',
    route: '/docs/change-log/2024-04-02-csv-export-for-premium-app-analytics',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_04_23_MODIFY_GUILD_MEMBER_FLAGS_FIELD_PERMISSIONS',
    name: 'Modify Guild Member flags field permissions',
    sidebarLabel: 'Modify Guild Member flags field permissions',
    filename: '2024-04-23-modify-guild-member-flags-field-permissions.md',
    category: 'change-log',
    subPath: 'change-log/2024-04-23-modify-guild-member-flags-field-permissions',
    route: '/docs/change-log/2024-04-23-modify-guild-member-flags-field-permissions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_04_24_PREMIUM_APPS_ONE_TIME_PURCHASES_AND_STORE',
    name: 'Premium Apps: One-Time Purchases and Store',
    sidebarLabel: 'Premium Apps: One-Time Purchases and Store',
    filename: '2024-04-24-premium-apps-one-time-purchases-and-store.md',
    category: 'change-log',
    subPath: 'change-log/2024-04-24-premium-apps-one-time-purchases-and-store',
    route: '/docs/change-log/2024-04-24-premium-apps-one-time-purchases-and-store',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_05_31_AUTO_MODERATION_MEMBER_PROFILE_RULE',
    name: 'Auto Moderation Member Profile Rule',
    sidebarLabel: 'Auto Moderation Member Profile Rule',
    filename: '2024-05-31-auto-moderation-member-profile-rule.md',
    category: 'change-log',
    subPath: 'change-log/2024-05-31-auto-moderation-member-profile-rule',
    route: '/docs/change-log/2024-05-31-auto-moderation-member-profile-rule',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_06_17_PREMIUM_APPS_NEW_PREMIUM_BUTTON_STYLE_DEEP_LINKING_URL_SCHEMES',
    name: 'Premium Apps: New Premium Button Style & Deep Linking URL Schemes',
    sidebarLabel: 'Premium Apps: New Premium Button Style & Deep Linking URL Schemes',
    filename: '2024-06-17-premium-apps-new-premium-button-style-deep-linking-url-schemes.md',
    category: 'change-log',
    subPath: 'change-log/2024-06-17-premium-apps-new-premium-button-style-deep-linking-url-schemes',
    route: '/docs/change-log/2024-06-17-premium-apps-new-premium-button-style-deep-linking-url-schemes',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_06_27_USER_INSTALLED_APPS_GENERAL_AVAILABILITY',
    name: 'User-Installed Apps General Availability',
    sidebarLabel: 'User-Installed Apps General Availability',
    filename: '2024-06-27-user-installed-apps-general-availability.md',
    category: 'change-log',
    subPath: 'change-log/2024-06-27-user-installed-apps-general-availability',
    route: '/docs/change-log/2024-06-27-user-installed-apps-general-availability',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_09_BANNERS_IN_GET_CURRENT_USER_GUILDS',
    name: 'Banners in Get Current User Guilds',
    sidebarLabel: 'Banners in Get Current User Guilds',
    filename: '2024-07-09-banners-in-get-current-user-guilds.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-09-banners-in-get-current-user-guilds',
    route: '/docs/change-log/2024-07-09-banners-in-get-current-user-guilds',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_15_MESSAGE_FORWARDING_ROLLOUT',
    name: 'Message Forwarding rollout',
    sidebarLabel: 'Message Forwarding rollout',
    filename: '2024-07-15-message-forwarding-rollout.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-15-message-forwarding-rollout',
    route: '/docs/change-log/2024-07-15-message-forwarding-rollout',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_16_MEMBER_BANNERS',
    name: 'Guild Member Banners',
    sidebarLabel: 'Guild Member Banners',
    filename: '2024-07-16-member-banners.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-16-member-banners',
    route: '/docs/change-log/2024-07-16-member-banners',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_17_ACTIVITIES_PROXY_CSP_UPDATE',
    name: 'Activities Proxy CSP Update',
    sidebarLabel: 'Activities Proxy CSP Update',
    filename: '2024-07-17-activities-proxy-csp-update.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-17-activities-proxy-csp-update',
    route: '/docs/change-log/2024-07-17-activities-proxy-csp-update',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_18_APPLICATION_EMOJI',
    name: 'Application Emoji',
    sidebarLabel: 'Application Emoji',
    filename: '2024-07-18-application-emoji.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-18-application-emoji',
    route: '/docs/change-log/2024-07-18-application-emoji',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_07_25_SUPPORTED_ACTIVITY_TYPES_FOR_SET_ACTIVITY',
    name: 'Supported Activity Types for SET_ACTIVITY',
    sidebarLabel: 'Supported Activity Types for SET_ACTIVITY',
    filename: '2024-07-25-supported-activity-types-for-set-activity.md',
    category: 'change-log',
    subPath: 'change-log/2024-07-25-supported-activity-types-for-set-activity',
    route: '/docs/change-log/2024-07-25-supported-activity-types-for-set-activity',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_05_VOICE_STATE_ENDPOINTS',
    name: 'Voice State Endpoints',
    sidebarLabel: 'Voice State Endpoints',
    filename: '2024-08-05-voice-state-endpoints.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-05-voice-state-endpoints',
    route: '/docs/change-log/2024-08-05-voice-state-endpoints',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_09_USER_APP_INSTALL_COUNT',
    name: 'User App Install Count',
    sidebarLabel: 'User App Install Count',
    filename: '2024-08-09-user-app-install-count.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-09-user-app-install-count',
    route: '/docs/change-log/2024-08-09-user-app-install-count',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_12_GET_GUILD_ROLE_ENDPOINT',
    name: 'Get Guild Role Endpoint',
    sidebarLabel: 'Get Guild Role Endpoint',
    filename: '2024-08-12-get-guild-role-endpoint.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-12-get-guild-role-endpoint',
    route: '/docs/change-log/2024-08-12-get-guild-role-endpoint',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_13_VOICE_ENCRYPTION_MODES',
    name: 'Voice Encryption Modes',
    sidebarLabel: 'Voice Encryption Modes',
    filename: '2024-08-13-voice-encryption-modes.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-13-voice-encryption-modes',
    route: '/docs/change-log/2024-08-13-voice-encryption-modes',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_13_VOICE_GATEWAY_VERSION_8_AND_DEPRECATION_OF_VERSIONS_OLDER_THAN_4',
    name: 'Voice Gateway Version 8 and Deprecation of Versions < 4',
    sidebarLabel: 'Voice Gateway Version 8 and Deprecation of Versions < 4',
    filename: '2024-08-13-voice-gateway-version-8-and-deprecation-of-versions-older-than-4.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-13-voice-gateway-version-8-and-deprecation-of-versions-older-than-4',
    route: '/docs/change-log/2024-08-13-voice-gateway-version-8-and-deprecation-of-versions-older-than-4',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_26_ENTRY_POINT_COMMANDS',
    name: 'Entry Point Commands',
    sidebarLabel: 'Entry Point Commands',
    filename: '2024-08-26-entry-point-commands.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-26-entry-point-commands',
    route: '/docs/change-log/2024-08-26-entry-point-commands',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_26_LAUNCHING_ACTIVITIES_VIA_INTERACTIONS',
    name: 'Launching Activities in Response to Interactions',
    sidebarLabel: 'Launching Activities in Response to Interactions',
    filename: '2024-08-26-launching-activities-via-interactions.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-26-launching-activities-via-interactions',
    route: '/docs/change-log/2024-08-26-launching-activities-via-interactions',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_08_28_SUBSCRIPTION_API_AND_ENTITLEMENT_MIGRATION',
    name: 'Premium Apps: Entitlement Migration and New Subscription API',
    sidebarLabel: 'Premium Apps: Entitlement Migration and New Subscription API',
    filename: '2024-08-28-subscription-api-and-entitlement-migration.md',
    category: 'change-log',
    subPath: 'change-log/2024-08-28-subscription-api-and-entitlement-migration',
    route: '/docs/change-log/2024-08-28-subscription-api-and-entitlement-migration',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_09_04_ADD_POLLS_WHEN_EDITING_DEFERRED_INTERACTION_RESPONSES',
    name: 'Add Polls when Editing Deferred Interaction Responses',
    sidebarLabel: 'Add Polls when Editing Deferred Interaction Responses',
    filename: '2024-09-04-add-polls-when-editing-deferred-interaction-responses.md',
    category: 'change-log',
    subPath: 'change-log/2024-09-04-add-polls-when-editing-deferred-interaction-responses',
    route: '/docs/change-log/2024-09-04-add-polls-when-editing-deferred-interaction-responses',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_09_17_VOICE_E2EE_DAVE_PROTOCOL',
    name: 'Voice End-to-End Encryption (DAVE Protocol)',
    sidebarLabel: 'Voice End-to-End Encryption (DAVE Protocol)',
    filename: '2024-09-17-voice-e2ee-dave-protocol.md',
    category: 'change-log',
    subPath: 'change-log/2024-09-17-voice-e2ee-dave-protocol',
    route: '/docs/change-log/2024-09-17-voice-e2ee-dave-protocol',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_09_26_ACTIVITIES_GENERAL_AVAILABILITY',
    name: 'Activities General Availability',
    sidebarLabel: 'Activities General Availability',
    filename: '2024-09-26-activities-general-availability.md',
    category: 'change-log',
    subPath: 'change-log/2024-09-26-activities-general-availability',
    route: '/docs/change-log/2024-09-26-activities-general-availability',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_10_04_UPDATES_TO_ENTITLEMENT_MIGRATION_GUIDE',
    name: 'Updates to Entitlement Migration Guide',
    sidebarLabel: 'Updates to Entitlement Migration Guide',
    filename: '2024-10-04-updates-to-entitlement-migration-guide.md',
    category: 'change-log',
    subPath: 'change-log/2024-10-04-updates-to-entitlement-migration-guide',
    route: '/docs/change-log/2024-10-04-updates-to-entitlement-migration-guide',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_10_25_EVENT_WEBHOOKS',
    name: 'Webhook Events',
    sidebarLabel: 'Webhook Events',
    filename: '2024-10-25-event-webhooks.md',
    category: 'change-log',
    subPath: 'change-log/2024-10-25-event-webhooks',
    route: '/docs/change-log/2024-10-25-event-webhooks',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_11_05_POST_ENTITLEMENT_MIGRATION_UPDATE',
    name: 'Entitlement Migration Completed',
    sidebarLabel: 'Entitlement Migration Completed',
    filename: '2024-11-05-post-entitlement-migration-update.md',
    category: 'change-log',
    subPath: 'change-log/2024-11-05-post-entitlement-migration-update',
    route: '/docs/change-log/2024-11-05-post-entitlement-migration-update',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_12_12_PREMIUM_APPS_MULTIPLE_SUBSCRIPTION_TIERS',
    name: 'Premium Apps: Multiple Subscription Tiers',
    sidebarLabel: 'Premium Apps: Multiple Subscription Tiers',
    filename: '2024-12-12-premium-apps-multiple-subscription-tiers.md',
    category: 'change-log',
    subPath: 'change-log/2024-12-12-premium-apps-multiple-subscription-tiers',
    route: '/docs/change-log/2024-12-12-premium-apps-multiple-subscription-tiers',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2024_12_17_UPDATED_FILE_UPLOAD_LIMIT',
    name: 'Default File Upload Limit Change',
    sidebarLabel: 'Default File Upload Limit Change',
    filename: '2024-12-17-updated-file-upload-limit.md',
    category: 'change-log',
    subPath: 'change-log/2024-12-17-updated-file-upload-limit',
    route: '/docs/change-log/2024-12-17-updated-file-upload-limit',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_03_17_INTRODUCING_THE_DISCORD_SOCIAL_SDK',
    name: 'Introducing the Discord Social SDK',
    sidebarLabel: 'Introducing the Discord Social SDK',
    filename: '2025-03-17-introducing-the-discord-social-sdk.md',
    category: 'change-log',
    subPath: 'change-log/2025-03-17-introducing-the-discord-social-sdk',
    route: '/docs/change-log/2025-03-17-introducing-the-discord-social-sdk',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_04_03_PER_ATTACHMENT_FILE_UPLOAD_LIMIT',
    name: 'Per-Attachment File Upload Behavior for Apps',
    sidebarLabel: 'Per-Attachment File Upload Behavior for Apps',
    filename: '2025-04-03-per-attachment-file-upload-limit.md',
    category: 'change-log',
    subPath: 'change-log/2025-04-03-per-attachment-file-upload-limit',
    route: '/docs/change-log/2025-04-03-per-attachment-file-upload-limit',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_04_11_INCENTIVIZED_LINKS',
    name: 'Custom Incentivized Links',
    sidebarLabel: 'Custom Incentivized Links',
    filename: '2025-04-11-incentivized-links.md',
    category: 'change-log',
    subPath: 'change-log/2025-04-11-incentivized-links',
    route: '/docs/change-log/2025-04-11-incentivized-links',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_04_15_DEPRECATING_GUILD_CREATEION_BY_APPS',
    name: 'Deprecating Guild Creation by Apps',
    sidebarLabel: 'Deprecating Guild Creation by Apps',
    filename: '2025-04-15-deprecating-guild-createion-by-apps.md',
    category: 'change-log',
    subPath: 'change-log/2025-04-15-deprecating-guild-createion-by-apps',
    route: '/docs/change-log/2025-04-15-deprecating-guild-createion-by-apps',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_04_16_DISCORD_SOCIAL_SDK_1',
    name: 'Discord Social SDK Release 1.1',
    sidebarLabel: 'Discord Social SDK Release 1.1',
    filename: '2025-04-16-discord-social-sdk-1.1.md',
    category: 'change-log',
    subPath: 'change-log/2025-04-16-discord-social-sdk-1',
    route: '/docs/change-log/2025-04-16-discord-social-sdk-1',
    subpages: [],
  },
  {
    key: 'CHANGE_LOG_2025_04_21_COMPONENTS_V2',
    name: 'Introducing New Components for Messages!',
    sidebarLabel: 'Introducing New Components for Messages!',
    filename: '2025-04-21-components-v2.md',
    category: 'change-log',
    subPath: 'change-log/2025-04-21-components-v2',
    route: '/docs/change-log/2025-04-21-components-v2',
    subpages: [],
  },
  {
    key: 'COMPONENTS_OVERVIEW',
    name: 'Components Overview',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'components',
    subPath: 'components/overview',
    route: '/docs/components/overview',
    subpages: [],
  },
  {
    key: 'COMPONENTS_REFERENCE',
    name: 'Component Reference',
    sidebarLabel: 'Component Reference',
    filename: 'reference.mdx',
    category: 'components',
    subPath: 'components/reference',
    route: '/docs/components/reference',
    subpages: [],
  },
  {
    key: 'COMPONENTS_USING_MESSAGE_COMPONENTS',
    name: 'Using Message Components',
    sidebarLabel: 'Using Message Components',
    filename: 'using-message-components.mdx',
    category: 'components',
    subPath: 'components/using-message-components',
    route: '/docs/components/using-message-components',
    subpages: [],
  },
  {
    key: 'COMPONENTS_USING_MODAL_COMPONENTS',
    name: 'Using Modal Components',
    sidebarLabel: 'Using Modal Components',
    filename: 'using-modal-components.mdx',
    category: 'components',
    subPath: 'components/using-modal-components',
    route: '/docs/components/using-modal-components',
    subpages: [],
  },
  {
    key: 'DEVELOPER_TOOLS_COMMUNITY_RESOURCES',
    name: 'Community Resources',
    sidebarLabel: 'Community Resources',
    filename: 'community-resources.mdx',
    category: 'developer-tools',
    subPath: 'developer-tools/community-resources',
    route: '/docs/developer-tools/community-resources',
    subpages: [],
  },
  {
    key: 'DEVELOPER_TOOLS_EMBEDDED_APP_SDK',
    name: 'Embedded App SDK Reference',
    sidebarLabel: 'Embedded App SDK',
    filename: 'embedded-app-sdk.mdx',
    category: 'developer-tools',
    subPath: 'developer-tools/embedded-app-sdk',
    route: '/docs/developer-tools/embedded-app-sdk',
    subpages: [],
  },
  {
    key: 'DEVELOPER_TOOLS_GAME_SDK',
    name: 'Game SDK',
    sidebarLabel: 'Game SDK',
    filename: 'game-sdk.mdx',
    category: 'developer-tools',
    subPath: 'developer-tools/game-sdk',
    route: '/docs/developer-tools/game-sdk',
    subpages: [],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_CORE_CONCEPTS',
    name: 'Core Concepts: Discord Social SDK',
    sidebarLabel: 'Core Concepts',
    filename: 'core-concepts.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/core-concepts',
    route: '/docs/discord-social-sdk/core-concepts',
    subpages: [],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES',
    name: 'Discord Social SDK Design Guidelines',
    sidebarLabel: 'Design Guidelines',
    filename: 'design-guidelines.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/design-guidelines',
    route: '/docs/discord-social-sdk/design-guidelines',
    subpages: [
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_PRINCIPLES',
        name: 'Principles',
        sidebarLabel: 'Principles',
        filename: 'design-guidelines/principles.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/principles',
        route: '/docs/discord-social-sdk/design-guidelines/principles',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_SIGNING_IN',
        name: 'Signing In',
        sidebarLabel: 'Signing In',
        filename: 'design-guidelines/signing-in.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/signing-in',
        route: '/docs/discord-social-sdk/design-guidelines/signing-in',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_CONNECTION_POINTS',
        name: 'Connection Points',
        sidebarLabel: 'Connection Points',
        filename: 'design-guidelines/connection-points.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/connection-points',
        route: '/docs/discord-social-sdk/design-guidelines/connection-points',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_BRANDING_GUIDELINES',
        name: 'Branding Guidelines',
        sidebarLabel: 'Branding Guidelines',
        filename: 'design-guidelines/branding-guidelines.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/branding-guidelines',
        route: '/docs/discord-social-sdk/design-guidelines/branding-guidelines',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_UNIFIED_FRIENDS_LIST',
        name: '{sidebar_label}',
        sidebarLabel: 'Unified Friends List',
        filename: 'design-guidelines/unified-friends-list.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/unified-friends-list',
        route: '/docs/discord-social-sdk/design-guidelines/unified-friends-list',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_DIRECT_MESSAGES',
        name: 'Direct Messages',
        sidebarLabel: 'Direct Messages',
        filename: 'design-guidelines/direct-messages.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/direct-messages',
        route: '/docs/discord-social-sdk/design-guidelines/direct-messages',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_PROVISIONAL_ACCOUNTS',
        name: 'Provisional Accounts',
        sidebarLabel: 'Provisional Accounts',
        filename: 'design-guidelines/provisional-accounts.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/provisional-accounts',
        route: '/docs/discord-social-sdk/design-guidelines/provisional-accounts',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_STATUS_RICH_PRESENCE',
        name: 'Status & Rich Presence',
        sidebarLabel: 'Status & Rich Presence',
        filename: 'design-guidelines/status-rich-presence.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/status-rich-presence',
        route: '/docs/discord-social-sdk/design-guidelines/status-rich-presence',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_CONSOLES',
        name: '{sidebar_label}',
        sidebarLabel: 'Consoles',
        filename: 'design-guidelines/consoles.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/consoles',
        route: '/docs/discord-social-sdk/design-guidelines/consoles',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_GAME_FRIENDS',
        name: '{sidebar_label}',
        sidebarLabel: 'Game Friends',
        filename: 'design-guidelines/game-friends.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/game-friends',
        route: '/docs/discord-social-sdk/design-guidelines/game-friends',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DESIGN_GUIDELINES_LINKED_CHANNELS',
        name: '{sidebar_label}',
        sidebarLabel: 'Linked Channels',
        filename: 'design-guidelines/linked-channels.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/design-guidelines/linked-channels',
        route: '/docs/discord-social-sdk/design-guidelines/linked-channels',
        subpages: [],
      },
    ],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES',
    name: 'Discord Social SDK Development Guides',
    sidebarLabel: 'Development Guides',
    filename: 'development-guides.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/development-guides',
    route: '/docs/discord-social-sdk/development-guides',
    subpages: [
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_ACCOUNT_LINKING_WITH_DISCORD',
        name: '{sidebar_label}',
        sidebarLabel: 'Account Linking with Discord',
        filename: 'development-guides/account-linking-with-discord.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/account-linking-with-discord',
        route: '/docs/discord-social-sdk/development-guides/account-linking-with-discord',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_ACCOUNT_LINKING_ON_CONSOLES',
        name: '{sidebar_label}',
        sidebarLabel: 'Account Linking on Consoles',
        filename: 'development-guides/account-linking-on-consoles.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/account-linking-on-consoles',
        route: '/docs/discord-social-sdk/development-guides/account-linking-on-consoles',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_USING_PROVISIONAL_ACCOUNTS',
        name: 'Using Provisional Accounts',
        sidebarLabel: 'Using Provisional Accounts',
        filename: 'development-guides/using-provisional-accounts.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/using-provisional-accounts',
        route: '/docs/discord-social-sdk/development-guides/using-provisional-accounts',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_CREATING_A_UNIFIED_FRIENDS_LIST',
        name: 'Creating a Unified Friends List',
        sidebarLabel: 'Creating a Unified Friends List',
        filename: 'development-guides/creating-a-unified-friends-list.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/creating-a-unified-friends-list',
        route: '/docs/discord-social-sdk/development-guides/creating-a-unified-friends-list',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_MANAGING_RELATIONSHIPS',
        name: 'Managing Relationships in Your Game',
        sidebarLabel: 'Managing Relationships',
        filename: 'development-guides/managing-relationships.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/managing-relationships',
        route: '/docs/discord-social-sdk/development-guides/managing-relationships',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_SETTING_RICH_PRESENCE',
        name: '{sidebar_label}',
        sidebarLabel: 'Setting Rich Presence',
        filename: 'development-guides/setting-rich-presence.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/setting-rich-presence',
        route: '/docs/discord-social-sdk/development-guides/setting-rich-presence',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_MANAGING_GAME_INVITES',
        name: '{sidebar_label}',
        sidebarLabel: 'Managing Game Invites',
        filename: 'development-guides/managing-game-invites.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/managing-game-invites',
        route: '/docs/discord-social-sdk/development-guides/managing-game-invites',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_SENDING_DIRECT_MESSAGES',
        name: '{sidebar_label}',
        sidebarLabel: 'Sending Direct Messages',
        filename: 'development-guides/sending-direct-messages.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/sending-direct-messages',
        route: '/docs/discord-social-sdk/development-guides/sending-direct-messages',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_MANAGING_LOBBIES',
        name: 'Creating and Managing Lobbies',
        sidebarLabel: 'Managing Lobbies',
        filename: 'development-guides/managing-lobbies.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/managing-lobbies',
        route: '/docs/discord-social-sdk/development-guides/managing-lobbies',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_LINKED_CHANNELS',
        name: '{sidebar_label}',
        sidebarLabel: 'Linked Channels',
        filename: 'development-guides/linked-channels.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/linked-channels',
        route: '/docs/discord-social-sdk/development-guides/linked-channels',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_JOINING_VOICE_CHAT',
        name: '{sidebar_label}',
        sidebarLabel: 'Joining Voice Chat',
        filename: 'development-guides/joining-voice-chat.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/joining-voice-chat',
        route: '/docs/discord-social-sdk/development-guides/joining-voice-chat',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_DEBUGGING_LOGGING',
        name: '{sidebar_label}',
        sidebarLabel: 'Debugging & Logging',
        filename: 'development-guides/debugging-logging.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/debugging-logging',
        route: '/docs/discord-social-sdk/development-guides/debugging-logging',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_DEVELOPMENT_GUIDES_USING_WITH_DISCORD_APIS',
        name: '{sidebar_label}',
        sidebarLabel: 'Using with Discord APIs',
        filename: 'development-guides/using-with-discord-apis.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/development-guides/using-with-discord-apis',
        route: '/docs/discord-social-sdk/development-guides/using-with-discord-apis',
        subpages: [],
      },
    ],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_GETTING_STARTED',
    name: 'Getting Started with the Discord Social SDK',
    sidebarLabel: 'Getting Started',
    filename: 'getting-started.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/getting-started',
    route: '/docs/discord-social-sdk/getting-started',
    subpages: [
      {
        key: 'DISCORD_SOCIAL_SDK_GETTING_STARTED_USING_C++',
        name: 'Getting Started with C++ and the Discord Social SDK',
        sidebarLabel: 'Using Standalone C++',
        filename: 'getting-started/using-c++.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/getting-started/using-c++',
        route: '/docs/discord-social-sdk/getting-started/using-c++',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_GETTING_STARTED_USING_UNITY',
        name: 'Getting Started with Unity and the Discord Social SDK',
        sidebarLabel: 'Using Unity',
        filename: 'getting-started/using-unity.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/getting-started/using-unity',
        route: '/docs/discord-social-sdk/getting-started/using-unity',
        subpages: [],
      },
      {
        key: 'DISCORD_SOCIAL_SDK_GETTING_STARTED_USING_UNREAL_ENGINE',
        name: 'Getting Started with Unreal Engine and the Discord Social SDK',
        sidebarLabel: 'Using Unreal Engine',
        filename: 'getting-started/using-unreal-engine.mdx',
        category: 'discord-social-sdk',
        subPath: 'discord-social-sdk/getting-started/using-unreal-engine',
        route: '/docs/discord-social-sdk/getting-started/using-unreal-engine',
        subpages: [],
      },
    ],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_OVERVIEW',
    name: 'Discord Social SDK',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/overview',
    route: '/docs/discord-social-sdk/overview',
    subpages: [],
  },
  {
    key: 'DISCORD_SOCIAL_SDK_SOCIAL_SDK_REFERENCE',
    name: 'social-sdk-reference',
    sidebarLabel: 'Social SDK Reference',
    filename: 'social-sdk-reference.mdx',
    category: 'discord-social-sdk',
    subPath: 'discord-social-sdk/social-sdk-reference',
    route: '/docs/discord-social-sdk/social-sdk-reference',
    subpages: [],
  },
  {
    key: 'DISCOVERY_BEST_PRACTICES',
    name: 'Discovery Best Practices',
    sidebarLabel: 'Best Practices',
    filename: 'best-practices.md',
    category: 'discovery',
    subPath: 'discovery/best-practices',
    route: '/docs/discovery/best-practices',
    subpages: [],
  },
  {
    key: 'DISCOVERY_ENABLING_DISCOVERY',
    name: 'Enabling Discovery',
    sidebarLabel: 'Enabling Discovery',
    filename: 'enabling-discovery.mdx',
    category: 'discovery',
    subPath: 'discovery/enabling-discovery',
    route: '/docs/discovery/enabling-discovery',
    subpages: [],
  },
  {
    key: 'DISCOVERY_OVERVIEW',
    name: 'Discovery on Discord',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'discovery',
    subPath: 'discovery/overview',
    route: '/docs/discovery/overview',
    subpages: [],
  },
  {
    key: 'EVENTS_GATEWAY_EVENTS',
    name: 'Gateway Events',
    sidebarLabel: 'Gateway Events',
    filename: 'gateway-events.mdx',
    category: 'events',
    subPath: 'events/gateway-events',
    route: '/docs/events/gateway-events',
    subpages: [],
  },
  {
    key: 'EVENTS_GATEWAY',
    name: 'Gateway',
    sidebarLabel: 'Using Gateway',
    filename: 'gateway.mdx',
    category: 'events',
    subPath: 'events/gateway',
    route: '/docs/events/gateway',
    subpages: [],
  },
  {
    key: 'EVENTS_OVERVIEW',
    name: 'Overview of Events',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'events',
    subPath: 'events/overview',
    route: '/docs/events/overview',
    subpages: [],
  },
  {
    key: 'EVENTS_WEBHOOK_EVENTS',
    name: 'Webhook Events',
    sidebarLabel: 'Webhook Events',
    filename: 'webhook-events.mdx',
    category: 'events',
    subPath: 'events/webhook-events',
    route: '/docs/events/webhook-events',
    subpages: [],
  },
  {
    key: 'INTERACTIONS_APPLICATION_COMMANDS',
    name: 'Application Commands',
    sidebarLabel: 'Application Commands',
    filename: 'application-commands.mdx',
    category: 'interactions',
    subPath: 'interactions/application-commands',
    route: '/docs/interactions/application-commands',
    subpages: [],
  },
  {
    key: 'INTERACTIONS_OVERVIEW',
    name: 'Overview of Interactions',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'interactions',
    subPath: 'interactions/overview',
    route: '/docs/interactions/overview',
    subpages: [],
  },
  {
    key: 'INTERACTIONS_RECEIVING_AND_RESPONDING',
    name: 'Interactions',
    sidebarLabel: 'Receiving and Responding',
    filename: 'receiving-and-responding.mdx',
    category: 'interactions',
    subPath: 'interactions/receiving-and-responding',
    route: '/docs/interactions/receiving-and-responding',
    subpages: [],
  },
  {
    key: 'MONETIZATION_ENABLING_MONETIZATION',
    name: 'Enabling Monetization',
    sidebarLabel: 'Enabling Monetization',
    filename: 'enabling-monetization.mdx',
    category: 'monetization',
    subPath: 'monetization/enabling-monetization',
    route: '/docs/monetization/enabling-monetization',
    subpages: [],
  },
  {
    key: 'MONETIZATION_IMPLEMENTING_APP_SUBSCRIPTIONS',
    name: 'Implementing App Subscriptions',
    sidebarLabel: 'Implementing App Subscriptions',
    filename: 'implementing-app-subscriptions.mdx',
    category: 'monetization',
    subPath: 'monetization/implementing-app-subscriptions',
    route: '/docs/monetization/implementing-app-subscriptions',
    subpages: [],
  },
  {
    key: 'MONETIZATION_IMPLEMENTING_IAP_FOR_ACTIVITIES',
    name: 'Implementing In-App Purchases for Activities',
    sidebarLabel: 'Implementing IAP for Activities',
    filename: 'implementing-iap-for-activities.mdx',
    category: 'monetization',
    subPath: 'monetization/implementing-iap-for-activities',
    route: '/docs/monetization/implementing-iap-for-activities',
    subpages: [],
  },
  {
    key: 'MONETIZATION_IMPLEMENTING_ONE_TIME_PURCHASES',
    name: 'Implementing One-Time Purchases',
    sidebarLabel: 'Implementing One-Time Purchases',
    filename: 'implementing-one-time-purchases.md',
    category: 'monetization',
    subPath: 'monetization/implementing-one-time-purchases',
    route: '/docs/monetization/implementing-one-time-purchases',
    subpages: [],
  },
  {
    key: 'MONETIZATION_MANAGING_SKUS',
    name: 'Managing SKUs',
    sidebarLabel: 'Managing SKUs',
    filename: 'managing-skus.mdx',
    category: 'monetization',
    subPath: 'monetization/managing-skus',
    route: '/docs/monetization/managing-skus',
    subpages: [],
  },
  {
    key: 'MONETIZATION_OVERVIEW',
    name: 'Monetizing Your Discord App',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'monetization',
    subPath: 'monetization/overview',
    route: '/docs/monetization/overview',
    subpages: [],
  },
  {
    key: 'POLICIES_AND_AGREEMENTS_DEVELOPER_POLICY',
    name: 'Discord Developer Policy',
    sidebarLabel: 'Developer Policy',
    filename: 'developer-policy.md',
    category: 'policies-and-agreements',
    subPath: 'policies-and-agreements/developer-policy',
    route: '/docs/policies-and-agreements/developer-policy',
    subpages: [],
  },
  {
    key: 'POLICIES_AND_AGREEMENTS_DEVELOPER_TERMS_OF_SERVICE',
    name: 'Discord Developer Terms of Service',
    sidebarLabel: 'Developer Terms of Service',
    filename: 'developer-terms-of-service.md',
    category: 'policies-and-agreements',
    subPath: 'policies-and-agreements/developer-terms-of-service',
    route: '/docs/policies-and-agreements/developer-terms-of-service',
    subpages: [],
  },
  {
    key: 'POLICIES_AND_AGREEMENTS_STORE_DISTRIBUTION_AGREEMENT',
    name: 'Discord Store Distribution Agreement for Developers (Self-Service)',
    sidebarLabel: 'Discord Store Distribution Agreement for Developers (Self-Service)',
    filename: 'store-distribution-agreement.md',
    category: 'policies-and-agreements',
    subPath: 'policies-and-agreements/store-distribution-agreement',
    route: '/docs/policies-and-agreements/store-distribution-agreement',
    subpages: [],
  },
  {
    key: 'QUICK_START_GETTING_STARTED',
    name: 'Building your first Discord app',
    sidebarLabel: 'Getting Started',
    filename: 'getting-started.mdx',
    category: 'quick-start',
    subPath: 'quick-start/getting-started',
    route: '/docs/quick-start/getting-started',
    subpages: [],
  },
  {
    key: 'QUICK_START_OVERVIEW_OF_APPS',
    name: 'Overview of Discord Apps',
    sidebarLabel: 'Overview of Apps',
    filename: 'overview-of-apps.mdx',
    category: 'quick-start',
    subPath: 'quick-start/overview-of-apps',
    route: '/docs/quick-start/overview-of-apps',
    subpages: [],
  },
  {
    key: 'RESOURCES_APPLICATION_ROLE_CONNECTION_METADATA',
    name: 'Application Role Connection Metadata',
    sidebarLabel: 'Application Role Connection Metadata',
    filename: 'application-role-connection-metadata.md',
    category: 'resources',
    subPath: 'resources/application-role-connection-metadata',
    route: '/docs/resources/application-role-connection-metadata',
    subpages: [],
  },
  {
    key: 'RESOURCES_APPLICATION',
    name: 'Application Resource',
    sidebarLabel: 'Application',
    filename: 'application.md',
    category: 'resources',
    subPath: 'resources/application',
    route: '/docs/resources/application',
    subpages: [],
  },
  {
    key: 'RESOURCES_AUDIT_LOG',
    name: 'Audit Logs Resource',
    sidebarLabel: 'Audit Log',
    filename: 'audit-log.md',
    category: 'resources',
    subPath: 'resources/audit-log',
    route: '/docs/resources/audit-log',
    subpages: [],
  },
  {
    key: 'RESOURCES_AUTO_MODERATION',
    name: 'Auto Moderation',
    sidebarLabel: 'Auto Moderation',
    filename: 'auto-moderation.md',
    category: 'resources',
    subPath: 'resources/auto-moderation',
    route: '/docs/resources/auto-moderation',
    subpages: [],
  },
  {
    key: 'RESOURCES_CHANNEL',
    name: 'Channels Resource',
    sidebarLabel: 'Channel',
    filename: 'channel.md',
    category: 'resources',
    subPath: 'resources/channel',
    route: '/docs/resources/channel',
    subpages: [],
  },
  {
    key: 'RESOURCES_EMOJI',
    name: 'Emoji Resource',
    sidebarLabel: 'Emoji',
    filename: 'emoji.md',
    category: 'resources',
    subPath: 'resources/emoji',
    route: '/docs/resources/emoji',
    subpages: [],
  },
  {
    key: 'RESOURCES_ENTITLEMENT',
    name: 'Entitlements Resource',
    sidebarLabel: 'Entitlement',
    filename: 'entitlement.md',
    category: 'resources',
    subPath: 'resources/entitlement',
    route: '/docs/resources/entitlement',
    subpages: [],
  },
  {
    key: 'RESOURCES_GUILD_SCHEDULED_EVENT',
    name: 'Guild Scheduled Event',
    sidebarLabel: 'Guild Scheduled Event',
    filename: 'guild-scheduled-event.mdx',
    category: 'resources',
    subPath: 'resources/guild-scheduled-event',
    route: '/docs/resources/guild-scheduled-event',
    subpages: [],
  },
  {
    key: 'RESOURCES_GUILD_TEMPLATE',
    name: 'Guild Template Resource',
    sidebarLabel: 'Guild Template',
    filename: 'guild-template.md',
    category: 'resources',
    subPath: 'resources/guild-template',
    route: '/docs/resources/guild-template',
    subpages: [],
  },
  {
    key: 'RESOURCES_GUILD',
    name: 'Guild Resource',
    sidebarLabel: 'Guild',
    filename: 'guild.md',
    category: 'resources',
    subPath: 'resources/guild',
    route: '/docs/resources/guild',
    subpages: [],
  },
  {
    key: 'RESOURCES_INVITE',
    name: 'Invite Resource',
    sidebarLabel: 'Invite',
    filename: 'invite.md',
    category: 'resources',
    subPath: 'resources/invite',
    route: '/docs/resources/invite',
    subpages: [],
  },
  {
    key: 'RESOURCES_LOBBY',
    name: 'Lobby Resource',
    sidebarLabel: 'Lobby',
    filename: 'lobby.md',
    category: 'resources',
    subPath: 'resources/lobby',
    route: '/docs/resources/lobby',
    subpages: [],
  },
  {
    key: 'RESOURCES_MESSAGE',
    name: 'Messages Resource',
    sidebarLabel: 'Message',
    filename: 'message.md',
    category: 'resources',
    subPath: 'resources/message',
    route: '/docs/resources/message',
    subpages: [],
  },
  {
    key: 'RESOURCES_POLL',
    name: 'Poll Resource',
    sidebarLabel: 'Poll',
    filename: 'poll.md',
    category: 'resources',
    subPath: 'resources/poll',
    route: '/docs/resources/poll',
    subpages: [],
  },
  {
    key: 'RESOURCES_SKU',
    name: 'SKU Resource',
    sidebarLabel: 'SKU',
    filename: 'sku.md',
    category: 'resources',
    subPath: 'resources/sku',
    route: '/docs/resources/sku',
    subpages: [],
  },
  {
    key: 'RESOURCES_SOUNDBOARD',
    name: 'Soundboard Resource',
    sidebarLabel: 'Soundboard',
    filename: 'soundboard.md',
    category: 'resources',
    subPath: 'resources/soundboard',
    route: '/docs/resources/soundboard',
    subpages: [],
  },
  {
    key: 'RESOURCES_STAGE_INSTANCE',
    name: 'Stage Instance Resource',
    sidebarLabel: 'Stage Instance',
    filename: 'stage-instance.md',
    category: 'resources',
    subPath: 'resources/stage-instance',
    route: '/docs/resources/stage-instance',
    subpages: [],
  },
  {
    key: 'RESOURCES_STICKER',
    name: 'Sticker Resource',
    sidebarLabel: 'Sticker',
    filename: 'sticker.md',
    category: 'resources',
    subPath: 'resources/sticker',
    route: '/docs/resources/sticker',
    subpages: [],
  },
  {
    key: 'RESOURCES_SUBSCRIPTION',
    name: 'Subscription Resource',
    sidebarLabel: 'Subscription',
    filename: 'subscription.md',
    category: 'resources',
    subPath: 'resources/subscription',
    route: '/docs/resources/subscription',
    subpages: [],
  },
  {
    key: 'RESOURCES_USER',
    name: 'Users Resource',
    sidebarLabel: 'User',
    filename: 'user.md',
    category: 'resources',
    subPath: 'resources/user',
    route: '/docs/resources/user',
    subpages: [],
  },
  {
    key: 'RESOURCES_VOICE',
    name: 'Voice Resource',
    sidebarLabel: 'Voice',
    filename: 'voice.md',
    category: 'resources',
    subPath: 'resources/voice',
    route: '/docs/resources/voice',
    subpages: [],
  },
  {
    key: 'RESOURCES_WEBHOOK',
    name: 'Webhook Resource',
    sidebarLabel: 'Webhook',
    filename: 'webhook.md',
    category: 'resources',
    subPath: 'resources/webhook',
    route: '/docs/resources/webhook',
    subpages: [],
  },
  {
    key: 'RICH_PRESENCE_BEST_PRACTICES',
    name: 'Best Practices for Rich Presence',
    sidebarLabel: 'Best Practices',
    filename: 'best-practices.md',
    category: 'rich-presence',
    subPath: 'rich-presence/best-practices',
    route: '/docs/rich-presence/best-practices',
    subpages: [],
  },
  {
    key: 'RICH_PRESENCE_OVERVIEW',
    name: 'Overview of Rich Presence',
    sidebarLabel: 'Overview',
    filename: 'overview.mdx',
    category: 'rich-presence',
    subPath: 'rich-presence/overview',
    route: '/docs/rich-presence/overview',
    subpages: [],
  },
  {
    key: 'RICH_PRESENCE_USING_WITH_THE_DISCORD_SOCIAL_SDK',
    name: 'Using Rich Presence with the Discord Social SDK',
    sidebarLabel: 'Using with the Discord Social SDK',
    filename: 'using-with-the-discord-social-sdk.mdx',
    category: 'rich-presence',
    subPath: 'rich-presence/using-with-the-discord-social-sdk',
    route: '/docs/rich-presence/using-with-the-discord-social-sdk',
    subpages: [],
  },
  {
    key: 'RICH_PRESENCE_USING_WITH_THE_EMBEDDED_APP_SDK',
    name: 'Using Rich Presence with the Embedded App SDK',
    sidebarLabel: 'Using with the Embedded App SDK',
    filename: 'using-with-the-embedded-app-sdk.mdx',
    category: 'rich-presence',
    subPath: 'rich-presence/using-with-the-embedded-app-sdk',
    route: '/docs/rich-presence/using-with-the-embedded-app-sdk',
    subpages: [],
  },
  {
    key: 'RICH_PRESENCE_USING_WITH_THE_GAME_SDK',
    name: 'Using Rich Presence with the Game SDK',
    sidebarLabel: 'Using with the Game SDK',
    filename: 'using-with-the-game-sdk.mdx',
    category: 'rich-presence',
    subPath: 'rich-presence/using-with-the-game-sdk',
    route: '/docs/rich-presence/using-with-the-game-sdk',
    subpages: [],
  },
  {
    key: 'TOPICS_CERTIFIED_DEVICES',
    name: 'Certified Devices',
    sidebarLabel: 'Certified Devices',
    filename: 'certified-devices.md',
    category: 'topics',
    subPath: 'topics/certified-devices',
    route: '/docs/topics/certified-devices',
    subpages: [],
  },
  {
    key: 'TOPICS_OAUTH2',
    name: 'OAuth2',
    sidebarLabel: 'OAuth2',
    filename: 'oauth2.md',
    category: 'topics',
    subPath: 'topics/oauth2',
    route: '/docs/topics/oauth2',
    subpages: [],
  },
  {
    key: 'TOPICS_OPCODES_AND_STATUS_CODES',
    name: 'Opcodes and Status Codes',
    sidebarLabel: 'Opcodes and Status Codes',
    filename: 'opcodes-and-status-codes.md',
    category: 'topics',
    subPath: 'topics/opcodes-and-status-codes',
    route: '/docs/topics/opcodes-and-status-codes',
    subpages: [],
  },
  {
    key: 'TOPICS_PERMISSIONS',
    name: 'Permissions',
    sidebarLabel: 'Permissions',
    filename: 'permissions.md',
    category: 'topics',
    subPath: 'topics/permissions',
    route: '/docs/topics/permissions',
    subpages: [],
  },
  {
    key: 'TOPICS_RATE_LIMITS',
    name: 'Rate Limits',
    sidebarLabel: 'Rate Limits',
    filename: 'rate-limits.md',
    category: 'topics',
    subPath: 'topics/rate-limits',
    route: '/docs/topics/rate-limits',
    subpages: [],
  },
  {
    key: 'TOPICS_RPC',
    name: 'RPC',
    sidebarLabel: 'RPC',
    filename: 'rpc.md',
    category: 'topics',
    subPath: 'topics/rpc',
    route: '/docs/topics/rpc',
    subpages: [],
  },
  {
    key: 'TOPICS_TEAMS',
    name: 'Teams',
    sidebarLabel: 'Teams',
    filename: 'teams.md',
    category: 'topics',
    subPath: 'topics/teams',
    route: '/docs/topics/teams',
    subpages: [],
  },
  {
    key: 'TOPICS_THREADS',
    name: 'Threads',
    sidebarLabel: 'Threads',
    filename: 'threads.md',
    category: 'topics',
    subPath: 'topics/threads',
    route: '/docs/topics/threads',
    subpages: [],
  },
  {
    key: 'TOPICS_VOICE_CONNECTIONS',
    name: 'Voice',
    sidebarLabel: 'Voice',
    filename: 'voice-connections.mdx',
    category: 'topics',
    subPath: 'topics/voice-connections',
    route: '/docs/topics/voice-connections',
    subpages: [],
  },
  {
    key: 'TUTORIALS_CONFIGURING_APP_METADATA_FOR_LINKED_ROLES',
    name: 'Configuring App Metadata for Linked Roles',
    sidebarLabel: 'Configuring App Metadata for Linked Roles',
    filename: 'configuring-app-metadata-for-linked-roles.md',
    category: 'tutorials',
    subPath: 'tutorials/configuring-app-metadata-for-linked-roles',
    route: '/docs/tutorials/configuring-app-metadata-for-linked-roles',
    subpages: [],
  },
  {
    key: 'TUTORIALS_DEVELOPING_A_USER_INSTALLABLE_APP',
    name: 'Developing A User-Installable App',
    sidebarLabel: 'Developing A User-Installable App',
    filename: 'developing-a-user-installable-app.mdx',
    category: 'tutorials',
    subPath: 'tutorials/developing-a-user-installable-app',
    route: '/docs/tutorials/developing-a-user-installable-app',
    subpages: [],
  },
  {
    key: 'TUTORIALS_HOSTING_ON_CLOUDFLARE_WORKERS',
    name: 'Hosting a Reddit API Discord app on Cloudflare Workers',
    sidebarLabel: 'Hosting on Cloudflare Workers',
    filename: 'hosting-on-cloudflare-workers.md',
    category: 'tutorials',
    subPath: 'tutorials/hosting-on-cloudflare-workers',
    route: '/docs/tutorials/hosting-on-cloudflare-workers',
    subpages: [],
  },
  {
    key: 'TUTORIALS_UPGRADING_TO_APPLICATION_COMMANDS',
    name: 'Upgrading Apps to Use Application Commands',
    sidebarLabel: 'Upgrading to Application Commands',
    filename: 'upgrading-to-application-commands.md',
    category: 'tutorials',
    subPath: 'tutorials/upgrading-to-application-commands',
    route: '/docs/tutorials/upgrading-to-application-commands',
    subpages: [],
  },
] as const;
